import { RefundOptions } from "@/pages/return-widget/components/line-item/refund-options";

export function RefundTypeSelect() {
  return <RefundOptions />;
}
